var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ejs-toolbar",
    { attrs: { id: "customToolbar" } },
    [
      _c(
        "e-items",
        [
          _c("e-item", {
            attrs: {
              id: "closePage",
              prefixIcon: _vm.icons.close,
              tooltipText: _vm.texts.close,
              click: _vm.closeViewerEvent,
            },
          }),
          _c("e-item", {
            attrs: {
              prefixIcon: _vm.icons.zoomIn,
              id: "zoomIn",
              align: "Center",
              tooltipText: _vm.texts.zoomIn,
              click: _vm.zoomInEvent,
              disabled: _vm.zoom === 10,
            },
          }),
          _c("e-item", {
            attrs: {
              prefixIcon: _vm.icons.zoomOut,
              id: "zoomOut",
              align: "Center",
              tooltipText: _vm.texts.zoomOut,
              click: _vm.zoomOutEvent,
              disabled: _vm.zoom === 1,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }